export default "__VITE_ASSET__D5e$X8V8__"